import React from "react";

/**
 * Label + control + inline error, so every field in the wizard reports
 * validation the same way instead of each section rolling its own.
 */
const FormField = ({ label, required, error, hint, className = "", children }) => (
  <div className={`mmh-field ${error ? "has-error" : ""} ${className}`}>
    {label && (
      <label>
        {label}
        {required && <span className="mmh-required">*</span>}
      </label>
    )}
    {children}
    {error ? (
      <span className="mmh-field-error">{error}</span>
    ) : (
      hint && <span className="mmh-field-hint">{hint}</span>
    )}
  </div>
);

export default FormField;
